/** Not a full list of card types - just ones with their own PLP */
const CardTypesWithPLP = [
  'INVITATION',
  'SAVE_THE_DATE',
  'DIGITAL_SAVE_THE_DATE',
  'CHANGE_THE_DATE',
  'THANK_YOU',
  'MENU',
  'PROGRAM',
  'PLACE',
  'HOLIDAY',
  'DETAILS',
  'MATCHING_SUITES',
  'WEDDING_SHOWER_INVITATION',
  'TABLE_NUMBER',
  'PAPER_ADD_ONS',
] as const;

/** A card type with its on product listing page */
export type PlpCardType = typeof CardTypesWithPLP[number];

export const isPlpCardType = (type: string): type is PlpCardType =>
  CardTypesWithPLP.includes(type as PlpCardType);
